import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "./EditableHeading.css"
import Heading from "../../../../clients/PastGeb/components/Heading/heading";
import UpdatePastGebTitle from "./package/UpdatePastGebTitle";
import CreateNewPastEdition from "./package/CreateNewPastEdition";
import WarningPopUp from "../../../../../components/WarningPopUp/WarningPopUp";
import DeletePastEdition from "./package/DeletePastEdition";
import { useNavigate } from "react-router";

const EditButton = ({ id, en, ed, el, isActionCreate, popUpTitle }) => {
    const [editionNumber, setEditionNumber] = useState(0);
    const [eventDate, setEventDate] = useState("");
    const [eventLocation, setEventLocation] = useState();
    const [btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
        setEditionNumber(en ?? "");
        setEventDate(ed ?? "");
        setEventLocation(el ?? "");
    }, [en, ed, el]);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isActionCreate) {
            let success = await CreateNewPastEdition({
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
                editionNumber: editionNumber,
                eventDate: eventDate,
                eventLocation: eventLocation
            });
            if (success) {
                refreshPage();
            }
        } else {
            let success = await UpdatePastGebTitle({
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
                id: id,
                editionNumber: editionNumber,
                eventDate: eventDate,
                eventLocation: eventLocation
            });
            if (success) {
                refreshPage();
            }
        }
    };

    return (
        <Popup
            trigger={
                isActionCreate ?
                    <div className="primary_btn">
                        Add New Past Edition
                    </div>
                    : <div className="ehp_edit_btn">
                        Edit
                    </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup">
                        <div className="ehp_inner_container">
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header">
                                    {popUpTitle ?? "Edit past Edition"}
                                </h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_left">
                                        <label htmlFor="edtion_num" className="geb_form_label">
                                            Edition Number:
                                        </label>
                                        <input
                                            id="edtion_num"
                                            type="number"
                                            value={editionNumber}
                                            onChange={(e) => {
                                                setEditionNumber(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                        <label htmlFor="edtion_num" className="geb_form_label">
                                            Event Date:
                                        </label>
                                        <input
                                            id="edtion_num"
                                            type="text"
                                            value={eventDate}
                                            onChange={(e) => {
                                                setEventDate(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                        <label htmlFor="edtion_num" className="geb_form_label">
                                            Event Location:
                                        </label>
                                        <input
                                            id="edtion_num"
                                            type="text"
                                            value={eventLocation}
                                            onChange={(e) => {
                                                setEventLocation(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup>
    );
};

const EditableHeading = ({ nth, eventDate, eventLocation, id, editionNumber }) => {
    let navigate = useNavigate();
    let [isBtnLoading, setIsBtnLoading] = useState(false);

    return (
        <div className="editableHomePage_container">
            <EditButton id={id} ed={eventDate} el={eventLocation} en={editionNumber} />
            <Heading nth={nth} eventDate={eventDate} eventLocation={eventLocation} />
            <div className="pe_warning_btns_container">
                <EditButton id={id}
                    ed={eventDate}
                    el={eventLocation}
                    en={editionNumber}
                    isActionCreate={true}
                />
                <div style={{ width: "3rem" }} />
                <WarningPopUp trigger={
                    <div className="primary_btn">
                        Delete {nth} Edition
                    </div>
                }
                    isBtnLoading={isBtnLoading}
                    popUpTitle={"Delete This Past Edition?"}
                    handelSubmit={async () => {
                        await DeletePastEdition({
                            setBtnLoading: setIsBtnLoading,
                            btnLoading: isBtnLoading,
                            id: id
                        });
                        navigate("/admin/home");
                    }}
                />
            </div>
        </div>
    );
};

export default EditableHeading;
